import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MySandboxComponent } from './my-sandbox.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MySandboxRoutingModule } from 'src/app/main/my-sandbox/my-sandbox-routing.module';
import { OurServicesModule } from 'src/app/main/service/our-services/our-services.module';
import { SandboxCardModule } from 'src/app/main/my-sandbox/sandbox-card/sandbox-card.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CarouselModule } from 'src/app/components/carousel/carousel.module';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';



@NgModule({
  declarations: [
    MySandboxComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,

    MySandboxRoutingModule,
    OurServicesModule,
    SandboxCardModule,
    CarouselModule,
    PageLoaderModule
  ]
})
export class MySandboxModule { }
